import React, { useEffect, useContext } from 'react';

import { Carousel } from 'src/components/carousel';
import { noop } from '@prisjakt/ui-base';

import ViewportContext from '../viewport/context';
import Modal from '../modal';

import * as S from './styles';

type Props = {
  items: React.ReactNode[];
  thumbnails?: React.ReactNode[];
  position?: number;
  close: () => void;
  onChange?: () => void;
  isOpen: boolean;
  width?: string;
};

const Lightbox = ({
  items,
  position = 0,
  thumbnails,
  onChange = noop,
  isOpen,
  close,
  width,
}: Props) => {
  const { isMobile } = useContext(ViewportContext);

  useEffect(() => {
    return () => {
      close();
    };
  });

  const height = isMobile ? '300px' : '450px';

  return (
    <Modal
      id="lightboxModal"
      isOpen={isOpen}
      onRequestClose={close}
      width={width}
      verticalScroll
    >
      <S.Lightbox>
        <Carousel
          focus
          height={height}
          position={position}
          onChange={onChange}
          thumbnails={isMobile ? null : thumbnails}
          clickForNext
        >
          {items.map(item => item)}
        </Carousel>
      </S.Lightbox>
    </Modal>
  );
};

export default Lightbox;
